import React, { createContext, useState, useContext, useEffect } from "react";
// Fix the import path - it should be one level up, not two
import api from "../utils/api";

const CryptoContext = createContext();

export const CryptoProvider = ({ children }) => {
  const [networks, setNetworks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNetworks = async () => {
    try {
      const response = await api.get("/crypto/networks");
      if (response.data.status === "success") {
        setNetworks(response.data.data.networks);
      }
    } catch (err) {
      setError("Failed to fetch crypto networks");
      // console.error("Crypto networks fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNetworks();
  }, []);

  return (
    <CryptoContext.Provider
      value={{ networks, loading, error, refetch: fetchNetworks }}
    >
      {children}
    </CryptoContext.Provider>
  );
};

export const useCrypto = () => useContext(CryptoContext);
